<!-- Navbar simple (style DPP) -->
@if (useSimpleNavbarStyle()) {
	<nav class="w-full bg-white fixed top-0 left-0 right-0 z-50 py-3 shadow">
		<div class="container">
			<div class="flex items-center justify-between !h-16">
				<a class="-mb-20 bg-white py-2 px-4" [routerLink]="(PrefixUrlCountryCode || '') + '/home'">
					<img class="w-24" [src]="getLogoPath()" alt="logo">
				</a>
	
				<div class="hidden md:block">
					<a *ngFor="let item of menuItems" [routerLink]="(PrefixUrlCountryCode || '') + item.href"
						routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
						class="nav-item nav-item-ltr">{{ item.label }}</a>
				</div>
	
				<div class="flex gap-x-4">
					<a href="" class="hidden text-sm items-center gap-x-1 lg:flex">
						<span class="text-primary">Besoin d'aide</span>
						<img class="w-4" src="icons/help.svg" alt="help">
					</a>
	
					@if (isLoggedIn()) {
					<div class="dropdown dropdown-end">
						<button class="flex items-center gap-x-2" tabindex="0" role="button">
							<div class="w-8 h-8 bg-primary/10 p-1 rounded-full">
								<img src="images/users/placeholder.png" alt="Header Avatar"
									class="rounded-circle header-profile-user rounded-full">
							</div>
							<p class="text-sm font-normal hidden lg:block">{{ (userData$ | async)?.firstName }} <span
									class="uppercase">{{ (userData$ | async)?.lastName }}</span></p>
							<lucide-icon [img]="ChevronDownIcon" [size]="16"></lucide-icon>
						</button>
						<ul class="dropdown-content z-[1] menu p-2 shadow bg-white rounded-box w-48">
							<li>
								<a [routerLink]="PrefixUrlCountryCode+'/passport'"
									class="text-gray-800 hover:bg-gray-100 w-full">
									Mon passeport
								</a>
							</li>
							<li>
								<a [routerLink]="PrefixUrlCountryCode+'/profil'"
									class="text-gray-800 hover:bg-gray-100 w-full">
									Mon profil
								</a>
							</li>
							<div class="w-full bg-gray-300 h-[1px] my-2"></div>
							<button (click)="logout()"
								class="flex items-center gap-x-2 text-red-400 hover:text-red-500 w-full px-3 py-2 rounded hover:bg-gray-100">
								<lucide-icon [img]="LogOutIcon" [size]="16"></lucide-icon>
								Déconnexion
							</button>
						</ul>
					</div>
					} @else {
					<button class="btn btn-primary !text-sm !py-2 !font-normal" (click)="openLoginModal()">Se
						connecter</button>
					@if (enableRegistration$ | async) {
					<a [routerLink]="(PrefixUrlCountryCode || '') + '/register'"
						class="btn btn-outline !text-sm !py-2 !font-normal ml-2">S'inscrire</a>
					}
					}
				</div>
			</div>
		</div>
	</nav>
	}
	
	<!-- Navbar complexe (style Eyone/MSAS/CI/etc.) -->
	@if (!useSimpleNavbarStyle()) {
	<nav class="fixed top-0 w-full left-0 right-0 shadow z-50">
		<div class="my-auto" [ngClass]="getNavbarBgClass()">
			<div class="container flex items-center justify-between h-18">
				<div class="flex items-center gap-x-3">
					<a [routerLink]="PrefixUrlCountryCode+'/home'" class="flex gap-x-2 items-center">
						<img [src]="getLogoPath()" alt="logo" class="w-10">
						<h1 class="hidden lg:block uppercase !text-[12px] !font-normal" [ngClass]="getNavbarTextClass()">
							{{ getNavbarTitle() }}
						</h1>
	
					</a>
					<button class="lg:hidden" (click)="toggleMenu()">
						<lucide-icon [img]="MenuIcon" [size]="24" [ngClass]="getNavbarTextClass()"></lucide-icon>
					</button>
				</div>
				<div class="flex items-center gap-x-3" [ngClass]="getNavbarTextClass()">
					@if (!isCountryChangeDisabled()) {
					<div class="dropdown md:dropdown-end sm:dropdown-center mr-2"
						[class.dropdown-open]="showCountryDropdown">
						<div tabindex="0" class="btn btn-ghost btn-sm px-2" (click)="toggleCountryDropdown()">
							<img *ngIf="selectedCountry" [src]="selectedCountry.flag" [alt]="selectedCountry.name"
								class="h-8 rounded shadow" />
							<span class="hidden md:inline text-xs font-medium ">{{ selectedCountry?.code }}</span>
						</div>
						<ul tabindex="0"
							class="dropdown-content menu p-2 shadow bg-white rounded-box w-64 max-h-80 overflow-y-auto">
							<li *ngFor="let country of countries$ | async">
								<button class="flex items-center gap-2 w-full px-2 py-1 hover:bg-base-200 rounded"
									(click)="setDefaultCountry(country)">
									<img [src]="country.flag" [alt]="country.name" class="h-5 w-8 rounded shadow" />
									<span class="text-sm font-medium text-gray-800">{{ country.name }}</span>
								</button>
							</li>
						</ul>
					</div>
					} @else {
					<!-- Afficher uniquement le drapeau du Sénégal sans dropdown sur le sous-domaine Orange -->
					<div class="flex items-center gap-2 mr-2">
						<img *ngIf="selectedCountry" [src]="selectedCountry.flag" [alt]="selectedCountry.name"
							class="h-8 rounded shadow" />
						<span class="hidden md:inline text-xs font-medium">{{ selectedCountry?.code }}</span>
					</div>
					}
	
					@if (isPassportRoute) {
					<a [routerLink]="PrefixUrlCountryCode+'/'" class="flex items-center gap-x-2">
						<button class="btn bg-white text-gray-800 hover:bg-gray-200 transition-all duration-300">
							{{ 'HEADER.GOTOPUBLIC' | translate }}
						</button>
					</a>
					}
					@if (isLoggedIn()) {
					<div class="dropdown dropdown-end">
						<button class="flex items-center gap-x-1" tabindex="0" role="button">
							<div class="w-9 h-9 bg-[#ffffff30] p-1 rounded-full">
								<img src="images/users/placeholder.png" alt="Header Avatar"
									class="rounded-circle header-profile-user rounded-full">
							</div>
							<p class="text-sm font-normal hidden lg:block">{{ (userData$ | async)?.firstName }} <span
									class="uppercase">{{ (userData$ |
									async)?.lastName }}</span></p>
							<lucide-icon [img]="ChevronDownIcon" [size]="16"></lucide-icon>
						</button>
						<ul class="dropdown-content z-[1] menu p-2 shadow bg-white rounded-box w-48">
							<li>
								<a [routerLink]="PrefixUrlCountryCode+'/passport'"
									class="text-gray-800 hover:bg-gray-100 w-full">
									Mon passeport
								</a>
							</li>
							<li>
								<a [routerLink]="PrefixUrlCountryCode+'/profil'"
									class="text-gray-800 hover:bg-gray-100 w-full">
									Mon profil
								</a>
							</li>
							<div class="w-full bg-gray-300 h-[1px] my-2"></div>
							<button (click)="logout()"
								class="flex items-center gap-x-2 text-red-400 hover:text-red-500 w-full px-3 py-2 rounded hover:bg-gray-100">
								<lucide-icon [img]="LogOutIcon" [size]="16"></lucide-icon>
								Déconnexion
							</button>
						</ul>
					</div>
					} @else {
					<button (click)="openLoginModal()"
						class="btn bg-white text-gray-800 hover:bg-gray-200 transition-all duration-300">
						{{ 'HEADER.LOGIN.MY_PASSPORT' | translate }}
					</button>
					@if (enableRegistration$ | async) {
					<a [routerLink]="(PrefixUrlCountryCode || '') + '/register'"
						class="btn bg-white text-gray-800 hover:bg-gray-200 transition-all duration-300 !text-sm !py-2 !font-normal ml-2">S'inscrire</a>
					}
					}
				</div>
			</div>
		</div>
		<!-- Menu mobile -->
		<div class="bg-white" [class.hidden]="!isMenuOpen" [class.md:flex]="true" [class.flex]="isMenuOpen">
			<div class="container">
				<div
					[ngClass]="{'flex': true, 'items-center': !isMenuOpen, 'gap-x-7': !isMenuOpen, 'py-4': true, 'flex-col gap-y-4': isMenuOpen}">
					@if (isPassportRoute) {
						@for (item of privateMenuItems$ | async; track item.path) {
						<a [routerLink]="PrefixUrlCountryCode+item.path" routerLinkActive="active"
							[routerLinkActiveOptions]="{exact: false}"
							class="text-[14px] text-gray-500 hover:text-primary transition-colors cursor-pointer active:text-primary">
							{{ item.label | translate }}
						</a>
						}
					} @else {
						@for (item of publicMenuItems; track item.path) {
						<a [routerLink]="PrefixUrlCountryCode+item.path" routerLinkActive="active"
							[routerLinkActiveOptions]="{exact: false}"
							class="text-[14px] text-gray-500 hover:text-primary transition-colors cursor-pointer active:text-primary">
							{{ item.label | translate }}
						</a>
						}
					}
				</div>
			</div>
		</div>
	</nav>
	}